import axios from '../requester';
import { LINB_API } from '../constants/api-urls';

export const getTeams = async ({ projectId }) =>
  await axios.get(`${LINB_API.PM_SERVICE.ENTITIES.AZURE_BOARDS.TEAMS}`, {
    params: {
      ...(projectId && { project_id: projectId })
    }
  });

export const getAreas = async ({ projectId, teamId, keyword }) =>
  await axios.get(`${LINB_API.PM_SERVICE.ENTITIES.AZURE_BOARDS.AREAS}`, {
    params: {
      ...(projectId && { project_id: projectId }),
      ...(teamId && { team_id: teamId }),
      ...(keyword && { keyword })
    }
  });
